import { render, staticRenderFns } from "./ReviewListing.vue?vue&type=template&id=2c3c4600&scoped=true&"
import script from "./ReviewListing.vue?vue&type=script&lang=ts&"
export * from "./ReviewListing.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewListing.vue?vue&type=style&index=0&id=2c3c4600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3c4600",
  null
  
)

export default component.exports